import Splide from '@splidejs/splide';

export default class WCArchiveTagsSlider {
    constructor() {
        this.tagsSlider = document.querySelector('.jsWcaTagsSlider');

        if (this.tagsSlider) {
            this.events();
        }
    }

    events() {
        this.initializeTagsSlider(this.tagsSlider);
    }

    initializeTagsSlider(tagsSlider) {
        // eslint-disable-next-line no-unused-vars
        this.activeSlider = new Splide(tagsSlider, {
            type: 'slide',
            rewind: false,
            arrows: true,
            pagination: false,
            autoWidth: true,
            gap: '0.8125rem',
            focus: 0,
            omitEnd: true,
            classes: {
                // Add classes for arrows.
                arrows: 'wca-tags__splide__arrows',
                arrow: 'wca-tags__splide__arrow',
                prev: 'wca-tags__splide__arrow--prev',
                next: 'wca-tags__splide__arrow--next',
            },
            breakpoints: {
                1023: {
                    drag: 'free',
                    arrows: false,
                },
            },
        }).mount();
    }
}
